// src/components/Tables/TableDataCargadaProductos.tsx
import '../../../MasOpciones/styles/bitacora.style.css';
import { useDispatch, useSelector } from 'react-redux';
import ModalCargarFileProductos from '../modals/ModalCargarFileProductos';
import { State } from '../../../../reducers';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Pagination } from '../../../../components/Pagination';
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton';
import BasicCardDocumentos from '../../../MasOpciones/Components/DatosDeCierre/BasicCardDocumentos';
import { postCargarProductos } from '../../../../actions/gestion-producto/agregar-producto/agregarProductoFile.actions';
import { KEYS } from '../../../../constants/keysStorage';
import * as http from '../../../../api/http';
import { ENDPOINTS } from '../../../../api/config';
import { GESTION_PRODUCTOS_TYPES } from '../../../../constants/gestionProducto.types';
import { generalShowLoader } from '../../../../actions/general.actions';
import { generalOpenModalError, generalOpenModalMessage } from '../../../../actions/general.actions';

const TableDataCargadaProductos = () => {
  const { productosFileDataCargada = {} } = useSelector((state: State) => state.productos || {});
  const { dataFile = [], form = {}, fileBase64 = '' } = productosFileDataCargada;

  const [modalCargarFile, setModalCargarFile] = useState<boolean>(false);
  const [currentItems, setCurrentItems] = useState<Array<any>>([]);
  const [sortedArray, setSortedArray] = useState<Array<any>>([]);
  const [progress, setProgress] = useState<number>(0); // porcentaje de progreso
  const { unidadesMedida, impuestosProducto } = useSelector((state: State) => state.catalogos);

  const dispatch = useDispatch();
  const history = useHistory();

  const mapUnidadMedida = (valor: string) => {
    if (!unidadesMedida) return "UND";
    const encontrado = unidadesMedida.find(u => u.valor.toLowerCase() === valor.toLowerCase());
    return encontrado ? encontrado.codigo : "UND";
  };

  const mapImpuesto = (descripcion: string) => {
    if (!impuestosProducto) return null;
    const encontrado = impuestosProducto.find(i => i.descripcion.toLowerCase() === descripcion.toLowerCase());
    return encontrado ? encontrado.idimpuesto : null;
  };

  const chunkArray = <T,>(array: T[], chunkSize: number): T[][] => {
    const chunks: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const handleCrearProductos = async () => {
  if (!form?.datosHacienda?.length || !form?.ext) return;

  setProgress(0);

  try {
    dispatch(generalShowLoader(true));

    const codigoempresa = localStorage.getItem(KEYS.CODIGO_EMPRESA);
    const resEmpresa = await http.get(`${ENDPOINTS.GESTION_PRODUCTO_GET_IDEMPRESA}?codigoempresa=${codigoempresa}`);
    const idEmpresaObtenido = (resEmpresa as any)?.data?.idempresa;
    if (!idEmpresaObtenido) throw new Error("No se pudo obtener el ID de la empresa");

    const resSucursalesActivas = await http.get(`${ENDPOINTS.GESTION_PRODUCTO_GET_SUCURSALES_ACTIVAS}?idempresa=${idEmpresaObtenido}`);
    const sucursalesActivas = (resSucursalesActivas as any)?.data || [];

    const sucursalesValidasCodigos = sucursalesActivas.map((s: any) => String(s.codigo).trim());
    const lineasInvalidas: number[] = [];

form.datosHacienda.forEach((item: any, index: number) => {
  const codigos = String(item.codigoSucursal || "")
    .split(",")
    .map(s => s.trim())
    .filter(s => s !== "");

  const invalido = codigos.some(c => !sucursalesValidasCodigos.includes(c));

  if (invalido) lineasInvalidas.push(index + 2);
});

if (lineasInvalidas.length > 0) {
  dispatch(generalShowLoader(false));

  const limite = 30;
  const filasMostradas = lineasInvalidas.slice(0, limite).join(", ");
  const textoExtra =
    lineasInvalidas.length > limite
      ? `... y ${lineasInvalidas.length - limite} filas más.`
      : "";

  dispatch(
    generalOpenModalError(
      `Se encontraron ${lineasInvalidas.length} códigos de sucursal inválidos.`,
      400
    )
  );

  dispatch(
    generalOpenModalMessage(
      "Verifique los siguientes registros",
      `
      Las siguientes filas del Excel contienen códigos de sucursal que no coinciden con ninguna sucursal activa:
        ${filasMostradas}
      ${textoExtra}
      `
    )
  );
  return;
}
    const datosFinales: any[] = [];

form.datosHacienda.forEach((item: any) => {
  const codigos = Array.from(new Set(
    String(item.codigoSucursal || "")
      .split(",")
      .map(s => s.trim())
      .filter(s => s !== "")
  ));

  const idsSucursales = codigos
    .map(cod => sucursalesActivas.find((s: any) => s.codigo === cod)?.idsucursal)
    .filter((id: any) => id != null);

  if (idsSucursales.length === 0) return;

  const tipoItem = String(item.servicioProducto).toLowerCase().includes("servicio") ? "0" : "1";
  const codigoUnidad = mapUnidadMedida(String(item.unidadMedida));

  let impuesto = item.impuestoDistintoAlIVA;
  if (!impuesto || ["no aplica", "n/a", "ninguno", "ninguna", ""].includes(String(impuesto).toLowerCase().trim())) {
    impuesto = [];
  } else {
    const idImpuesto = mapImpuesto(String(impuesto));
    impuesto = idImpuesto != null ? [Number(idImpuesto)] : [];
  }

  datosFinales.push({
    idEmpresa: idEmpresaObtenido,
    idsSucursales,
    clave: String(item.codigoProducto).toUpperCase(),
    descripcion: item.descripcion,
    precioUnitarioDefault: item.precioUnitario,
    unidad: codigoUnidad,
    tipoItem,
    ivaincluido: true,
    usuarioCreacion: localStorage.getItem(KEYS.USERNAME_CLIENTE) || "desconocido",
    Impuestos: impuesto,
  });
});



    const chunks = chunkArray(datosFinales, 100);
    let allSuccessful = true;

    for (let i = 0; i < chunks.length; i++) {
      const newForm = { ...form, datosHacienda: chunks[i] };
      const result = await postCargarProductos(newForm, fileBase64)(dispatch);
      if (!result) allSuccessful = false;
      setProgress(Math.round(((i + 1) / chunks.length) * 200));
    }

    dispatch(generalShowLoader(false));

    if (allSuccessful) {
      dispatch(
        generalOpenModalMessage(
          "Productos cargados exitosamente",
          "Todos los productos han sido ingresados al sistema."
        )
      );
      history.push("/gestion-productos/agregar-producto");
    } else {
      dispatch(
        generalOpenModalError(
          "Algunos productos no se pudieron cargar.",
          400
        )
      );
    }
  } catch (error) {
    dispatch(generalShowLoader(false));
    dispatch(generalOpenModalError("Ocurrió un error inesperado al cargar los productos."));
  }
};


  useEffect(() => setSortedArray(currentItems), [currentItems]);

  useEffect(() => {
    return () => {
      dispatch({ type: GESTION_PRODUCTOS_TYPES.PRODUCTOS_CLEAR });
    };
  }, [dispatch]);

  return (
    <>
      {modalCargarFile &&
        <ModalCargarFileProductos onAccept={() => setModalCargarFile(false)} onClose={() => setModalCargarFile(false)} />
      }
      <div className="w-layout-layout bill-section wf-layout-layout">
        <BasicCardDocumentos style={{ boxShadow: 'none', padding: '0' }} title="Validar datos" size="l">
          <div style={{ display: 'flex', justifyContent: 'start', marginTop: '8px', marginBottom: '16px' }}>
            <button className="button w-auto" onClick={() => setModalCargarFile(true)}>Cargar nuevo producto</button>
          </div>

          {progress > 0 && progress < 100 && (
            <div style={{ marginBottom: '8px' }}>Cargando productos... {progress}%</div>
          )}

          <div className="tab-plane">
            <div className="table-facturacion-resp">
              <table className="table-main-responsive responsive-table-main td-left table-pointer">
                <thead>
                  <tr>
                    <td>Sucursal en Feles <FilterButton keyName='sucursalFeles' data={sortedArray} state={setSortedArray} /></td>
                    <td>Codigo Sucursal en Feles <FilterButton keyName='codigoSucursal' data={sortedArray} state={setSortedArray} /></td>
                    <td>Código del Producto (De tu Inventario) <FilterButton keyName='codigoProducto' data={sortedArray} state={setSortedArray} /></td>
                    <td>Precio Unitario <FilterButton keyName='precioUnitario' data={sortedArray} state={setSortedArray} /></td>
                    <td>Servicio o Producto <FilterButton keyName='servicioProducto' data={sortedArray} state={setSortedArray} /></td>
                    <td>Unidad de Medida (Catalogo del MH) <FilterButton keyName='unidadMedida' data={sortedArray} state={setSortedArray} /></td>
                    <td>Descripcion del Producto <FilterButton keyName='descripcion' data={sortedArray} state={setSortedArray} /></td>
                    <td>Impuesto distinto al IVA a aplicar <FilterButton keyName='impuestoDistintoAlIVA' data={sortedArray} state={setSortedArray} /></td>
                  </tr>
                </thead>
                <tbody>
                  {sortedArray.map((item: any, index: number) => (
                    <tr key={index}>
                      <td data-label='Sucursal en Feles'>{item.sucursalFeles}</td>
                      <td data-label='Codigo Sucursal en Feles'>{item.codigoSucursal}</td>
                      <td data-label='Código del Producto (De tu Inventario)'>{String(item.codigoProducto).toUpperCase()}</td>
                      <td data-label='Precio Unitario'>{item.precioUnitario}</td>
                      <td data-label='Servicio o Producto'>{item.servicioProducto}</td>
                      <td data-label='Unidad de Medida'>{item.unidadMedida}</td>
                      <td data-label='Descripcion del Producto'>{item.descripcion}</td>
                      <td data-label='Impuesto distinto al IVA a aplicar'>{item.impuestoDistintoAlIVA}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {dataFile.length > 0 && (
                <Pagination data={dataFile} state={setCurrentItems} items={20} />
              )}
            </div>
          </div>
          {sortedArray.length > 0 && (
            <div style={{ display: 'flex', justifyContent: 'end', marginTop: '16px', marginBottom: '16px' }}>
              <button className="button w-auto" onClick={handleCrearProductos}>Agregar Productos</button>
            </div>
          )}
        </BasicCardDocumentos>
      </div>
    </>
  );
};

export default TableDataCargadaProductos;
